module.exports = __webpack_public_path__ + "img/工会系统.f246da27.png";